<template>
    <div id="checkinlog">
        <div class="container">
            <form @submit.prevent="submitCheckinlog">
                <h3 class="swif-blue-color" style="word-wrap: break-word;">{{ merchantname }}</h3>
                <br>
                <div class="form-group">
                    <label>Branches</label>
                    <select class="form-control" style="font-size: 16px;" v-model="branch" id="branch">
                        <option value="" disabled selected>Select Branch</option>
                        <option value="all">All Branches</option>
                        <option v-for="brancheslist in brancheslist" v-bind:key="brancheslist.branch_id" :value="brancheslist.branch_id">
                            {{brancheslist.branch_name}} <span v-if="brancheslist.status === '0'">(DELETED)</span>
                        </option>
                    </select>
                    <small id="error-branch" class="form-text invalid-feedback"></small>
                </div>
                <div class="form-group">
                    <label>Start Date</label>
                    <input type="date" class="form-control" id="startdate" v-model="startdate">
                    <small id="error-startdate" class="form-text invalid-feedback"></small>
                </div>
                <div class="form-group">
                    <label>End Date</label>
                    <input type="date" class="form-control" id="enddate" v-model="enddate">
                    <small id="error-enddate" class="form-text invalid-feedback"></small>
                </div>
                <button type="submit" class="btn btn-swif-yellow">Submit</button>
            </form>
            <br>
            <div v-if="isResult" class="shadow-sm p-3 mb-5 bg-white rounded">
                <div class="table-responsive">
                    <table class="table table-bordered" id="datalistDataTable">
                        <thead>
                            <tr>
                                <th scope="col">No</th>
                                <th scope="col">Date & Time</th>
                                <th scope="col">Name</th>
                                <th scope="col">Contact No</th>
                                <th scope="col">Temperature</th>
                                <th scope="col">Branch</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="userlist in userlist" v-bind:key="userlist.no">
                                <td>{{userlist.no}}</td>
                                <td>{{userlist.date}} {{userlist.time}}</td>
                                <td>{{userlist.name}}</td>
                                <td>{{userlist.phone}}</td>
                                <td>{{userlist.temperature}}</td>
                                <td>{{userlist.branchname}} <span v-if="userlist.status === '0'">(DELETED)</span></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import $ from 'jquery'
import 'datatables.net-bs4'
import 'jszip'
import 'datatables.net-buttons-bs4'
import 'datatables.net-buttons/js/buttons.html5'
import {firebaseApp,firebaseDefaultDateTime} from '../components/firebase/init'
const db = firebaseApp.firestore()
export default {
    name: 'checkinlog',
    data(){
        return{
            merchantname: "",
            brancheslist: [],
            branch: "",
            startdate: "",
            enddate: "",
            userlist: [],
            isResult: false,
        }
    },
    created() {
        this.getAllBranches()
    },
    beforeRouteEnter(to,from,next){
        const merchant_id = to.params.merchant_id;
        db.collection('merchant').doc(merchant_id).get().then(doc=>{
            if(doc.exists){
                next(vm=>{
                    vm.merchantname = doc.data().name
                })
            }else{
                next('/error404');
            }
        }).catch(function(error) {
            console.log("Error getting document:", error);
        });
    },
    watch: {
        '$route':'getMerchantName'
    },
    methods:{
        getMerchantName(){
            const merchant_id = this.$route.params.merchant_id;
            db.collection('merchant').doc(merchant_id).get().then(doc=>{
                if(doc.exists){
                    this.$data.merchantname = doc.data().name;
                }else{
                    this.$router.push('/error404')
                }
            }).catch(function(error) {
                console.log("Error getting document:", error);
            });
        },
        getAllBranches(){
            const merchant_id = this.$route.params.merchant_id;
            db.collection('merchant').doc(merchant_id)
            .collection('branch').where("mid","==",merchant_id).orderBy("name").onSnapshot(snapshot => {
                this.$data.brancheslist = [];
                snapshot.forEach(doc =>{
                    var data = {
                        'branch_id': doc.data().bid,
                        'branch_name': doc.data().name,
                        'status': doc.data().status
                    }
                    this.$data.brancheslist.push(data)
                })
            })
        },
        submitCheckinlog(){
            [].forEach.call(document.querySelectorAll('.is-invalid'), function (el) {
                el.classList.remove('is-invalid');
            });

            [].forEach.call(document.querySelectorAll('.invalid-feedback'), function (el) {
                el.innerHTML = "";
            });

            var valid = true;
            var branch = this.branch;
            var start = this.startdate;
            var end = this.enddate;
            var query;
            const merchant_id = this.$route.params.merchant_id;

            if(branch == ""){
                document.getElementById("branch").classList.add("is-invalid");
                document.getElementById("error-branch").innerHTML = "Please select branch";
                valid = false;
            }

            if(start == ""){
                document.getElementById("startdate").classList.add("is-invalid");
                document.getElementById("error-startdate").innerHTML = "Start date cannot be blank";
                valid = false;
            }

            if(end == ""){
                document.getElementById("enddate").classList.add("is-invalid");
                document.getElementById("error-enddate").innerHTML = "End date cannot be blank";
                valid = false;
            }

            if(start !="" && end != ""){
                if((Date.parse(end) < Date.parse(start))){
                    document.getElementById("enddate").classList.add("is-invalid");
                    document.getElementById("error-enddate").innerHTML = "End Date should be greater than Start Date";
                    valid = false;
                }
            }
            
            if(valid === true){
                $(".loader").show();

                var a = start.split("-");
                var as = new Date(a[0], a[1] - 1, a[2]);
                var b = end.split("-");
                var bs = new Date(b[0], b[1] - 1, b[2],23,59,59);

                var startdate = firebaseDefaultDateTime.Timestamp.fromDate(as);
                var enddate = firebaseDefaultDateTime.Timestamp.fromDate(bs);

                if(branch == "all"){
                    query = db.collection("checkinlog").where("mid","==",merchant_id).where("datesort",">=",startdate).where("datesort","<=",enddate).orderBy("datesort");
                }else{
                    query = db.collection("checkinlog").where("bid","==",branch).where("datesort",">=",startdate).where("datesort","<=",enddate).orderBy("datesort");
                }

                query.onSnapshot(snapshot => {
                    this.$data.userlist = [];
                    let i = 0;
                    let datalist = [];
                    snapshot.forEach(doc => {
                        i = i+1;
                        var temperature = doc.data().temperature;
                        if(temperature == ""){
                            temperature = "-";
                        }
                        var userdata = {
                            'no': i,
                            'name': doc.data().name,
                            'phone': doc.data().contactno,
                            'temperature': temperature,
                            'date': doc.data().date,
                            'time': doc.data().time,
                            'branchname': doc.data().branchname,
                            'branch_id': doc.data().bid
                        }
                        datalist.push(userdata)
                    })

                    const mergeById = (a1, a2) =>
                        a1.map(itm => ({
                            ...a2.find((item) => (item.branch_id === itm.branch_id) && item),
                            ...itm
                        })
                    );

                    this.$data.userlist = mergeById(datalist, this.$data.brancheslist);
                    this.isResult = true;
                
                    $('#datalistDataTable').DataTable().destroy();
                    this.$nextTick(function() {
                        $('#datalistDataTable').DataTable({
                            'retrieve': true,
                            'pagingType': 'numbers',
                            'responsive': true,
                            'info':     false,
                            'order': [],
                            'dom': 'Bfrtip',
                            'buttons': [{'extend': 'csvHtml5', text:'Download', 'className': 'btn btn-download',title: 'Swif. - Checkin'} ]
                        });
                        $(".loader").hide(); 
                    })

                })
            }
        }
    }
}
</script>